import apiClient from "../client";
import { cachedGet } from "../cache";
import { API_ENDPOINTS } from "../endpoints";
import type {
  ApiResponse,
  PaginatedApiResponse,
  Product,
  Profile,
  ProfileFilters,
  ProfilePhoto,
  Service,
  TrackingResponse,
} from "../interface";

export const profileService = {
  async getAll(params: ProfileFilters = {}) {
    return cachedGet<PaginatedApiResponse<Profile>>(
      API_ENDPOINTS.profiles.all,
      { params }
    );
  },

  async getBySlug(slug: string) {
    return cachedGet<ApiResponse<Profile>>(
      API_ENDPOINTS.profiles.detail(slug)
    );
  },

  async getByPublicId(publicId: string) {
    return cachedGet<ApiResponse<Profile>>(
      API_ENDPOINTS.profiles.publicDetail(publicId)
    );
  },

  async getPhotos(slug: string) {
    return cachedGet<ApiResponse<ProfilePhoto[]>>(
      API_ENDPOINTS.profiles.photos(slug)
    );
  },

  async getServices(slug: string) {
    return cachedGet<ApiResponse<Service[]>>(
      API_ENDPOINTS.profiles.services(slug)
    );
  },

  async getProducts(slug: string) {
    return cachedGet<ApiResponse<Product[]>>(
      API_ENDPOINTS.profiles.products(slug)
    );
  },

  async getPosts<T = unknown>(slug: string) {
    return cachedGet<ApiResponse<T[]>>(
      API_ENDPOINTS.profiles.posts(slug)
    );
  },

  async getComments<T = unknown>(slug: string) {
    return cachedGet<ApiResponse<T[]>>(
      API_ENDPOINTS.profiles.comments(slug)
    );
  },

  async registerView(slug: string) {
    const response = await apiClient.post<TrackingResponse>(
      API_ENDPOINTS.profiles.view(slug)
    );

    return response.data;
  },

  async registerWhatsAppClick(slug: string) {
    const response = await apiClient.post<TrackingResponse>(
      API_ENDPOINTS.profiles.whatsappClick(slug)
    );

    return response.data;
  },

  async registerTelegramClick(slug: string) {
    const response = await apiClient.post<TrackingResponse>(
      API_ENDPOINTS.profiles.telegramClick(slug)
    );

    return response.data;
  },
};
